'use strict';

Object.defineProperty(exports, '__esModule', {
  value: true
});

var _createClass = (function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ('value' in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; })();

exports.aggregateFactory = aggregateFactory;

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { 'default': obj }; }

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError('Cannot call a class as a function'); } }

var _utilsClone = require('./utils/clone');

var _utilsClone2 = _interopRequireDefault(_utilsClone);

var _group = require('./group');

var Aggregate = (function () {
  function Aggregate() {
    var obj = arguments.length <= 0 || arguments[0] === undefined ? {} : arguments[0];

    _classCallCheck(this, Aggregate);

    this.provider = obj.provider;
    this.collectionName = obj.collectionName;
    this.pipeline = obj.pipeline;
    this.pageSize = obj.pageSize;
  }

  _createClass(Aggregate, [{
    key: 'max',
    value: function max(fieldName) {
      var group = (0, _group.groupFactory)();
      return this.addGroup(group.max(fieldName));
    }
  }, {
    key: 'min',
    value: function min(fieldName) {
      var group = (0, _group.groupFactory)();
      return this.addGroup(group.min(fieldName));
    }
  }, {
    key: 'avg',
    value: function avg(fieldName) {
      var group = (0, _group.groupFactory)();
      return this.addGroup(group.avg(fieldName));
    }
  }, {
    key: 'sum',
    value: function sum(fieldName) {
      var group = (0, _group.groupFactory)();
      return this.addGroup(group.sum(fieldName));
    }
  }, {
    key: 'distinct',
    value: function distinct(fieldName) {
      var group = (0, _group.groupFactory)(fieldName);
      return this.addGroup(group);
    }
  }, {
    key: 'addFilter',
    value: function addFilter(filter) {
      return this._addPhase({ '$match': filter._build() });
    }
  }, {
    key: 'addSort',
    value: function addSort(sort) {
      return this._addPhase({ '$sort': sort._build() });
    }
  }, {
    key: 'addGroup',
    value: function addGroup(group) {
      return this._addPhase({ '$group': group._build() });
    }
  }, {
    key: 'skip',
    value: function skip(skipNumber) {
      return this._addPhase({ '$skip': skipNumber });
    }
  }, {
    key: 'limit',
    value: function limit(limitNumber) {
      return this._addPhase({ '$limit': limitNumber });
    }
  }, {
    key: 'setPageSize',
    value: function setPageSize(pageSizeNumber) {
      return this._copy(this.pipeline, pageSizeNumber);
    }
  }, {
    key: 'run',
    value: function run() {
      var _this = this;

      var self = this;
      return this.provider.runAggregate(this.collectionName, this.pipeline, this.pageSize).then(function (runResult) {
        return new WixDataAggregateResult({
          items: runResult.items,
          hasNext: runResult.hasNext,
          aggregate: self,
          pageSize: _this.pageSize
        });
      });
    }
  }, {
    key: '_addPhase',
    value: function _addPhase(phase) {
      var pipeline = (0, _utilsClone2['default'])(this.pipeline);
      pipeline.push(phase);
      return this._copy(pipeline, this.pageSize);
    }
  }, {
    key: '_copy',
    value: function _copy(pipeline, pageSize) {
      return new this.constructor(Object.assign({}, this, { pipeline: pipeline, pageSize: pageSize }));
    }
  }]);

  return Aggregate;
})();

exports.Aggregate = Aggregate;

function aggregateFactory(provider, collectionName) {
  return new Aggregate({
    provider: provider,
    collectionName: collectionName,
    pipeline: [],
    pageSize: 50
  });
}

var WixDataAggregateResult = (function () {
  function WixDataAggregateResult(obj) {
    _classCallCheck(this, WixDataAggregateResult);

    if (!obj) {
      return;
    }
    this._items = obj.items;
    this._hasNext = obj.hasNext;
    this._aggregate = obj.aggregate;
    this._pageSize = obj.pageSize;
  }

  _createClass(WixDataAggregateResult, [{
    key: 'hasNext',
    value: function hasNext() {
      return this._hasNext;
    }
  }, {
    key: 'next',
    value: function next() {
      var aggregate = this._aggregate;
      var pipeline = (0, _utilsClone2['default'])(aggregate.pipeline);
      if (lastPhase(pipeline).hasOwnProperty('$skip')) {
        var skipPhase = lastPhase(pipeline);
        var restOfPipeline = pipeline.slice(0, -1);
        var newAggregate = aggregate._copy(restOfPipeline, this._pageSize).skip(skipPhase['$skip'] + this._pageSize);
        return newAggregate.run();
      } else {
        var newAggregate = aggregate.skip(aggregate.pageSize);
        return newAggregate.run();
      }
    }
  }, {
    key: 'items',
    get: function get() {
      return this._items;
    }
  }, {
    key: 'length',
    get: function get() {
      return this._items.length;
    }
  }]);

  return WixDataAggregateResult;
})();

exports.WixDataAggregateResult = WixDataAggregateResult;

function lastPhase(pipeline) {
  return pipeline.slice(-1)[0];
}